import { render, staticRenderFns } from "./SearchFormBox.vue?vue&type=template&id=1726e5c6&scoped=true&"
import script from "./SearchFormBox.vue?vue&type=script&lang=js&"
export * from "./SearchFormBox.vue?vue&type=script&lang=js&"
import style0 from "./SearchFormBox.vue?vue&type=style&index=0&id=1726e5c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1726e5c6",
  null
  
)

export default component.exports